import { render, staticRenderFns } from "./SimpleCollapse.vue?vue&type=template&id=eeb50a3a&scoped=true"
import script from "./SimpleCollapse.vue?vue&type=script&lang=js"
export * from "./SimpleCollapse.vue?vue&type=script&lang=js"
import style0 from "./SimpleCollapse.vue?vue&type=style&index=0&id=eeb50a3a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb50a3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eeb50a3a')) {
      api.createRecord('eeb50a3a', component.options)
    } else {
      api.reload('eeb50a3a', component.options)
    }
    module.hot.accept("./SimpleCollapse.vue?vue&type=template&id=eeb50a3a&scoped=true", function () {
      api.rerender('eeb50a3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/SimpleCollapse.vue"
export default component.exports